import React, { useState, useEffect } from "react";
import {
  Fab,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import "../dashboard/AdminDashboard.css";
import "../Ticket/TicketDashboard.css";
import { TicketAPI } from "../../services/dbApi";
import { toast } from "react-toastify";

const MAX_SUBJECT_LENGTH = 100;
const MAX_DESC_LENGTH = 1000;

const TicketDashboard = () => {
  const [ticketList, setTicketList] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [newTicket, setNewTicket] = useState({ subject: "", description: "" });
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const response = await TicketAPI.fetchTickets();
        const data = response.data;

        if (!Array.isArray(data)) {
          console.error("Unexpected data:", data);
          setTicketList([]);
          return;
        }
        setTicketList(data);
      } catch (err) {
        console.error("Error fetching tickets:", err);
        setTicketList([]);
      }
    };
    fetchTickets();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const maxLength = name === "subject" ? MAX_SUBJECT_LENGTH : MAX_DESC_LENGTH;
    setNewTicket((prev) => ({
      ...prev,
      [name]: value.slice(0, maxLength),
    }));
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setNewTicket({ subject: "", description: "" });
  };

  const handleSubmit = async () => {

    const subject = newTicket.subject.trim();
    const description = newTicket.description.trim();

  // Basic frontend validation (to match backend)
    const regex = /^[A-Za-z0-9\s.,!?'"()\-@:\/]+$/;
    
    if (!subject || !description) {
      toast.error("Subject and Description are required.", { toastId: "required-fields" });
      return;
    }
    if (!regex.test(subject)) {
      toast.error("Subject can only contain letters.",{ toastId: "invalid-subject" });  
      return;
    }
    if (!regex.test(description)) {
      toast.error("Description can only contain letters.",{ toastId: "invalid-description" });  
      return;
    }
 

  try {
    const response = await TicketAPI.submitTicket({ subject, description });
    const result = response.data;

    const createdTicket = {
      ticket_id: result.ticket_id || Date.now(), // fallback if backend doesn't send ID
      subject,
      description,
      status: "Open",
      created_at: new Date().toISOString(),
    };

    setTicketList((prev) => [...prev, createdTicket]);
    handleCloseForm();

    setSuccessMessage("Ticket created successfully!");

    setTimeout(() => {
      setSuccessMessage("");
    }, 1000);
  } catch (err) {
    console.error("Error submitting ticket:", err);
    toast.error("Failed to submit ticket.", { toastId: "submit-failed" });  
  }
};

  const TABLE_HEADS = [
    "Ticket ID",
    "Subject",
    "Description",
    "Status",
    "Priority",
    "Resolution Remarks",
    "Created At",
  ];

  const formatDate = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleDateString() : "-";

  return (
    <>
      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}

      <div className="content-area-table-ticket">
        <h1 className="dashboard-heading">Issue Dashboard</h1>
        <div className="data-table-diagram-ticket">
          <table>
            <thead>
              <tr>
                {TABLE_HEADS.map((th, i) => (
                  <th key={i}>{th}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ticketList.map((ticket, i) => (
                <tr key={i}>
                  <td>{ticket.ticket_id}</td>
                  <td>{ticket.subject}</td>
                  <td
                    title={ticket.description}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "200px",
                    }}
                  >
                    {ticket.description.length > 20
                      ? ticket.description.slice(0, 20) + "..."
                      : ticket.description}
                  </td>
                  <td>{ticket.status || "Open"}</td>
                  <td>{ticket.priority || "Not Assigned"}</td>
                  <td>{ticket["resolution remarks"] || "None"}</td>
                  <td>{formatDate(ticket.created_at)}</td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>

      <Fab className="add-ticket-fab" aria-label="add" onClick={() => setOpenForm(true)}>
        <AddIcon />
      </Fab>

{openForm && (
        <div className="custom-dialog-overlay">
          <div className="custom-dialog">
            <div className="custom-dialog-header">
              <h2>Submit Ticket</h2>
              <button className="close-btn" onClick={handleCloseForm}>
                &times;
              </button>
            </div>
            <div className="custom-dialog-content">
              <form className="ticket-form" onSubmit={(e) => e.preventDefault()}>
                <label htmlFor="subject" className="form-label">Subject</label>
                <input
                  id="subject"
                  type="text"
                  name="subject"
                  placeholder="Briefly describe the issue"
                  value={newTicket.subject}
                  onChange={handleChange}
                  maxLength={MAX_SUBJECT_LENGTH}
                  className="form-input subject-input"
                />
                <small className="helper-text">
                  {newTicket.subject.length}/{MAX_SUBJECT_LENGTH} characters
                </small>
 
                <label htmlFor="description" className="form-label">Description</label>
                <textarea
                  id="description"
                  name="description"
                  placeholder="Provide a detailed description"
                  rows={4}
                  value={newTicket.description}
                  onChange={handleChange}
                  maxLength={MAX_DESC_LENGTH}
                  className="form-textarea"
                />
                <small className="helper-text">
                  {newTicket.description.length}/{MAX_DESC_LENGTH} characters
                </small>
            
                <p style={{ color: "red"}}>
                  (Only these special characters are allowed: . , ! ? ' " ( ) - @)
                </p>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="submit-ticket-btn"
                >
                  Submit Ticket
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TicketDashboard;


